import { render, staticRenderFns } from "./WebGameBox.vue?vue&type=template&id=787ed975&scoped=true&"
import script from "./WebGameBox.vue?vue&type=script&lang=js&"
export * from "./WebGameBox.vue?vue&type=script&lang=js&"
import style0 from "./WebGameBox.vue?vue&type=style&index=0&id=787ed975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ed975",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787ed975')) {
      api.createRecord('787ed975', component.options)
    } else {
      api.reload('787ed975', component.options)
    }
    module.hot.accept("./WebGameBox.vue?vue&type=template&id=787ed975&scoped=true&", function () {
      api.rerender('787ed975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/WebGameBox.vue"
export default component.exports